/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const RailLeftIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Rail Left',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M34.875 4H1.125A1.146 1.146 0 0 0 0 5.167v25.666A1.146 1.146 0 0 0 1.125 32h33.75A1.146 1.146 0 0 0 36 30.833V5.167A1.146 1.146 0 0 0 34.875 4ZM9.3 24H2.7v-2h6.6Zm0-6H2.7v-2h6.6Zm0-6H2.7v-2h6.6ZM34 30H12V10h22Z"
    />
  </svg>`;
};
